import { createAction } from '@reduxjs/toolkit';

const homeAct = {
  SET_PAGENAME: createAction<string>('SET_PAGENAME'),
};
export default homeAct;
